import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { FONTS, SPACES } from 'src/constants'

interface IStyleProps {
  isRoundImage?: boolean
}

const useStyles = makeStyles((theme: Theme) => ({
  formTitleWrapper: {
    '&&': {
      marginLeft: SPACES.xs,
      maxWidth: '800px',
    },
  },
  breadcrumbsWrapper: {
    marginBottom: SPACES.xxxxxl,

    maxWidth: 800,
    display: 'flex',
    gap: SPACES.xxxxxxl,
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  breadcrumbText: {
    '&&': {
      fontSize: FONTS.SIZES.m,
      lineHeight: 1.357,
      textTransform: 'none',
      fontWeight: FONTS.WEIGHTS.bold,
      color: theme.palette.custom.primary,

      '&:disabled': {
        fontWeight: FONTS.WEIGHTS.light,
        color: theme.palette.custom.darkBlue2,
      },
    },
  },
  titleWrapper: {
    '&&': {
      marginBottom: SPACES.xxxxl,

      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
  },
  titleWrapperLeft: {
    '&&': {
      display: 'flex',
      alignItems: 'center',
    },
  },
  imageWrapper: {
    '&&': {
      marginRight: SPACES.xl,
    },
  },
  imageInputWrapper: {
    position: 'relative',
    width: 80,
    height: 80,
  },
  moreIconWrapper: {
    '&&': {
      position: 'absolute',
      bottom: 0,
      right: '50%',
      transform: 'translate(50%, 50%)',
      padding: 2,

      backgroundColor: theme.palette.custom.surfaceMain,

      '&:hover, &:focus': {
        backgroundColor: theme.palette.custom.surfaceMain,
      },
    },
  },
  moreIcon: {
    '&&': {
      color: theme.palette.custom.white,
    },
  },
  popOverPrimary: {
    '&&': {
      color: theme.palette.custom.darkBlue2,
      fontWeight: FONTS.WEIGHTS.bold,
      fontSize: FONTS.SIZES.m,
    },
  },
  image: ({ isRoundImage }) => ({
    '&&': {
      width: 80,
      height: 80,

      backgroundColor: '#fff',

      [theme.breakpoints.down('tablet')]: {
        boxShadow: isRoundImage ? `0px 4px 10px rgba(0, 0, 0, 0.1)` : 'none',
      },

      [theme.breakpoints.up('tablet')]: {
        boxShadow: isRoundImage ? `0px 2px 10px ${theme.palette.custom.grey}` : 'none',
      },

      objectFit: 'cover',
      borderRadius: isRoundImage ? '50%' : 10,
    },
  }),
  imageIconWrapper: ({ isRoundImage }: IStyleProps) => ({
    '&&': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',

      width: 80,
      height: 80,

      borderRadius: isRoundImage ? '50%' : 10,
      border: `2px dashed ${theme.palette.custom.grey2}`,
    },
  }),

  imageIcon: {
    width: 24,
    height: 24,
  },
  helperText: {
    '&&': {
      maxWidth: 80,

      fontSize: FONTS.SIZES.xs,
      textAlign: 'center',
      wordBreak: 'break-word',
    },
  },
  titleText: {
    '&&': {
      fontWeight: 700,
      fontSize: FONTS.SIZES.xxxxl,
      lineHeight: 1.375,
      marginRight: SPACES.m,

      color: theme.palette.custom.darkBlue2,
    },
  },
  menuItemWrapper: {
    '&&': {
      marginBottom: SPACES.xxxxxl,
    },
  },

  previewWrapper: {
    '&&': {
      borderRadius: '10px',
      overflow: 'hidden',

      [theme.breakpoints.down('tablet')]: {
        maxWidth: 'calc(100vw - 50px)',
        maxHeight: 'calc(100vh - 200px)',
      },
      [theme.breakpoints.up('tablet')]: {
        maxHeight: 'calc(100vh - 150px)',
        maxWidth: '720px',
      },
    },
  },
  imagePreview: {
    display: 'block',
    width: '100%',
    height: 'auto',

    aspectRatio: '1/1',
    objectFit: 'contain',
  },
  imageIconButton: {
    '&&': {
      padding: 0,
      overflow: 'hidden',
      borderRadius: '50%',
    },
  },
}))

export default useStyles
